import React from 'react';
import { RIVERWOOD_HEADER_IMAGE } from '../../data/mockData';

const RiverwoodPreview = ({ content }) => {
  return (
    <div className="font-serif text-sm" style={{ fontFamily: 'Georgia, Times, serif' }}>
      {/* Page 1 - Header and Introduction */}
      <div className="p-8">
        {/* Title Section */}
        <div className="mb-2">
          <h1 
            className="text-xl font-bold mb-2"
            style={{ color: '#2d5016' }}
          >
            {content.header.title || '[Newsletter Title]'}
          </h1>
          <h2 
            className="text-3xl mb-2"
            style={{ color: '#2d5016', fontWeight: 'normal' }}
          >
            {content.header.subtitle || '[Subtitle]'}
          </h2>
          <p 
            className="text-sm font-semibold"
            style={{ color: '#b8860b' }}
          >
            {content.header.edition || '[Season/Edition]'}
          </p>
        </div>

        {/* Header Image Banner - THE RIVERWOOD - Using exact uploaded image */}
        <div className="my-6">
          <img 
            src={RIVERWOOD_HEADER_IMAGE} 
            alt="The Riverwood" 
            className="w-full h-auto"
            style={{ maxHeight: '150px', objectFit: 'cover' }}
          />
        </div>

        {/* Introduction Section */}
        <div className="mb-6">
          <h3 
            className="text-lg mb-3"
            style={{ color: '#2d5016' }}
          >
            {content.introductions.title || '[Section Title]'}
          </h3>
          <p 
            className="leading-relaxed text-sm text-gray-700"
          >
            {content.introductions.body || '[Introduction text - to be provided by user]'}
          </p>
        </div>

        {/* Footer Triangle Decoration */}
        <div className="flex justify-end mt-auto">
          <div 
            className="w-0 h-0"
            style={{
              borderLeft: '40px solid transparent',
              borderBottom: '40px solid #2d5016',
            }}
          />
        </div>
      </div>

      {/* Page Break Indicator */}
      <div className="border-t-2 border-dashed border-gray-300 my-4 mx-8" />

      {/* Page 2 - Introductions / Board & Staff */}
      <div className="p-8">
        <h2 className="text-xl font-bold mb-6" style={{ color: '#2d5016' }}>
          Introductions
        </h2>

        <div className="border border-gray-200 rounded-lg p-5">
          <h3 className="text-base font-bold text-gray-800 mb-4">
            First things first: Building Caretakers (Board & Staff)
          </h3>

          {/* Co-op Board */}
          <div className="mb-4">
            <h4 className="font-bold text-gray-700 text-sm mb-2">Co-op Board</h4>
            <div className="grid grid-cols-2 gap-1 text-sm">
              {content.introductions.board.map((member, index) => (
                <div key={index} className="flex">
                  <span className="text-gray-600 w-32">{member.role}:</span>
                  <span className="text-gray-800 font-medium">{member.name || '[Name]'}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Staff */}
          <div className="mb-4">
            <h4 className="font-bold text-gray-700 text-sm mb-2">Staff</h4>
            <div className="grid grid-cols-2 gap-1 text-sm">
              {content.introductions.staff.map((staff, index) => (
                <div key={index} className="flex">
                  <span className="text-gray-600 w-32">{staff.role}:</span>
                  <span className="text-gray-800 font-medium">{staff.name || '[Name]'}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Management */}
          <div className="mb-4">
            <h4 className="font-bold text-gray-700 text-sm mb-2">Management</h4>
            <div className="text-sm">
              <span className="text-gray-600">{content.introductions.management.role}: </span>
              <span className="text-gray-800 font-medium">{content.introductions.management.name || '[Name]'}</span>
            </div>
          </div>

          {/* Newsletter Team */}
          <div>
            <h4 className="font-bold text-gray-700 text-sm mb-1">Newsletter Team</h4>
            <p className="text-sm text-gray-600">Brought to you by your Board members!!</p>
          </div>
        </div>

        {/* Footer Triangle */}
        <div className="flex justify-end mt-6">
          <div 
            className="w-0 h-0"
            style={{
              borderLeft: '40px solid transparent',
              borderBottom: '40px solid #2d5016',
            }}
          />
        </div>
        <p className="text-right text-xs text-gray-400 mt-1">2</p>
      </div>

      {/* Page Break Indicator */}
      <div className="border-t-2 border-dashed border-gray-300 my-4 mx-8" />

      {/* Page 3 - From the Board */}
      <div className="p-8">
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          {content.from_the_board.title || 'From the Board:'}
        </h2>
        <div className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
          {content.from_the_board.body || '[Board message - to be provided by user]'}
        </div>

        {/* Footer Triangle */}
        <div className="flex justify-end mt-6">
          <div 
            className="w-0 h-0"
            style={{
              borderLeft: '40px solid transparent',
              borderBottom: '40px solid #2d5016',
            }}
          />
        </div>
        <p className="text-right text-xs text-gray-400 mt-1">3</p>
      </div>

      {/* Page Break Indicator */}
      <div className="border-t-2 border-dashed border-gray-300 my-4 mx-8" />

      {/* Page 4 - Housekeeping Rules */}
      <div className="p-8">
        {/* Remember Sticky Note */}
        <div className="flex justify-center mb-4">
          <div 
            className="bg-yellow-300 px-6 py-3 shadow-md transform -rotate-1"
            style={{ 
              borderLeft: '4px solid #dc2626',
              boxShadow: '3px 3px 8px rgba(0,0,0,0.2)',
            }}
          >
            <span className="font-bold text-gray-800 text-lg" style={{ fontFamily: 'cursive, serif' }}>
              Remember!!
            </span>
          </div>
        </div>

        <h2 className="text-xl font-bold text-gray-800 mb-4 text-center">
          {content.housekeeping_rules.title || 'Housekeeping/House Rules Reminders'}
        </h2>

        <div className="space-y-2">
          {content.housekeeping_rules.rules.length > 0 ? (
            content.housekeeping_rules.rules.map((rule, index) => (
              <div 
                key={index} 
                className="bg-gray-50 border border-gray-200 rounded p-3 text-sm text-gray-700"
              >
                {rule}
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-center italic">[Add rules using the editor]</p>
          )}
        </div>

        {/* Footer Triangle */}
        <div className="flex justify-end mt-6">
          <div 
            className="w-0 h-0"
            style={{
              borderLeft: '40px solid transparent',
              borderBottom: '40px solid #2d5016',
            }}
          />
        </div>
        <p className="text-right text-xs text-gray-400 mt-1">4</p>
      </div>
    </div>
  );
};

export default RiverwoodPreview;
